export const TAB_ALLEGATI_GENERICI = 'AllegatiGenerici';
export const TAB_ALLEGATI_ARTICOLI = 'AllegatiArticoli';
export const TAB_ALLEGATI_DIPENDENTI = 'AllegatiDipendenti';
export const TAB_ALLEGATI_MOVIMENTI = 'AllegatiMovimenti';

export const PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI = 'giorni-pre-alert-articoli';

export const RUOLO_AMMINISTRATORE = 'AMMINISTRATORE';
export const RUOLO_OPERATORE_AVANZATO = 'OPERATORE_AVANZATO';
export const RUOLO_OPERATORE_BASE = 'OPERATORE_BASE';

export const NOME_MODULO_BARCODE = "BarCodeConsRest";